import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaArrowDown } from 'react-icons/fa';

const ScrollButton = styled.button`
  position: fixed;
  top: 30px; /* Updated positioning */
  right: 30px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  display: ${(props) => (props.show ? 'block' : 'none')};
  
  &:hover {
    background-color: #0056b3;
    transform: scale(1.1);
  }
`;

const ScrollDownButton = () => {
  const [showButton, setShowButton] = useState(false);

  const scrollDown = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (documentHeight - (scrollY + windowHeight) > 100) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <ScrollButton  show={showButton} onClick={scrollDown}>
      <FaArrowDown />
    </ScrollButton>
  );
};

export default ScrollDownButton;
